import styled from "styled-components";

import { PrincipalTitle, TiersTitle } from "./Commun.style";
import PaperTextureWide from "../asset/pictures/paper-texture-wide.png";

const BackgroundColor = styled.div`
  width: 100%;
  height: 100%;
  border-bottom: solid #385da6 1px;
  background-color: #385da6;
  background-image: url(${PaperTextureWide});
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: top;

  &:hover ${TiersTitle}, &:hover ${PrincipalTitle} {
    color: #f24b4b;
  }

  &:hover {
    background-image: url(${(props) => props.backgroundImg});
  }
`;

const BackgroundImg = styled.img`
  width: 50%;
  margin-top: 100px;
`;

const Absolute = styled.div`
  position: absolute;
  width: 16%;
  top: 40px;
  left: -20px;
}
`;

const ColorSection = styled.div`
  background-color: ${(props) => props.backgroundColor};
  height: 50vh;
`;

export { BackgroundColor, BackgroundImg, ColorSection, Absolute };
